import { z } from 'zod';

export const GET_SCHEMA = z.enum([
  'bank',
  'free_parking',
]);